import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      user: 'user/user'
    }),
    isLoggedIn: function () {
      return !!this.user
    },
    isStoreUser: function () {
      return this.isLoggedIn && this.user.type === 'store_user'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/authentication.js